import { FiPlus } from "react-icons/fi";
import { CategoryIcon } from "./CategoryIcon";
import { CategoryActionsMenu } from "./CategoryActionsMenu";
import type { CSSProperties } from "react";
import { AppButton } from "@/components/ui/primitives";

export type CategoryCardProps = {
  name: string;
  icon?: string | null;
  color?: { name: string; hex: string } | null;
  noMovementLabel: string;
  amount: string;
  hasMovement: boolean;
  share: number;
  shareLabel: string;
  actions: { edit: string; view: string; delete: string; menu: string };
  onOpen: () => void;
  onEdit: () => void;
  onView: () => void;
  onDelete: () => void;
};


export const CategoryCard = ({ name, amount, share, shareLabel, hasMovement, noMovementLabel, actions, onOpen, onEdit, onView, onDelete, wide, featuredLabel, color, icon }: CategoryCardProps & { wide?: boolean; featuredLabel?: string }) => {
  const percent = Math.min(100, Math.max(0, share));
  const colorStyle = { "--category-color": color?.hex ?? "var(--ds-surface-raised)", "--category-track": color ? `color-mix(in srgb, ${color.hex} 55%, var(--ds-on-track))` : "var(--ds-line)", "--category-ink": color ? "var(--ds-on-card)" : "var(--ds-ink)" } as CSSProperties;
  return (
    <article className={`category-card${wide ? " category-card--wide" : ""}`} style={colorStyle}>
      <div className="category-card-head">
        <span className="category-card-icon" aria-hidden="true"><CategoryIcon name={icon} /></span>
        {wide && <span className="category-card-chip">{featuredLabel}</span>}
        <CategoryActionsMenu name={name} actions={actions} onEdit={onEdit} onView={onView} onDelete={onDelete} />
      </div>
      <button type="button" className="category-card-open app-focus-ring" onClick={onOpen}>
        <span className="category-card-name">{name}</span>
        <span className="category-card-amount">{amount}</span>
      </button>
      <div className="category-card-bar" role="progressbar" aria-label={`${name}: ${shareLabel}`} aria-valuemin={0} aria-valuemax={100} aria-valuenow={percent} aria-valuetext={`${percent}% ${shareLabel}`}><span style={{width: `${percent}%`}} /></div>
      <div className="category-card-foot">{hasMovement ? `${Math.round(percent)}% ${shareLabel}` : <><span>{noMovementLabel}</span><span>0%</span></>}</div>
    </article>
  );
};

export const CategoryCardAdd = ({onClick, label, hint}: {onClick: () => void; label: string; hint: string}) => <AppButton onClick={onClick} className="category-card category-card-add"><span className="category-card-icon"><FiPlus size={22} /></span><b>{label}</b><span>{hint}</span></AppButton>;
